import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Form, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators, UntypedFormControl } from '@angular/forms';
import { PostLambdaService } from './post-lambda.service';
import { Request } from './model.component';
import { Airports } from './model.component';
import { RentalCars } from './model.component';
import { Hotels } from './model.component';
import { HotelBoards } from './model.component';
import { EquipmentDurations } from './model.component';
import { EquipmentWingPremiumBoards } from './model.component';
import { EquipmentWindsurfPremiumBoards } from './model.component';
import { EquipmentWindsurfWorldCupBoards } from './model.component';
import { EquipmentWindsurfKidsBoards } from './model.component';
import { EquipmentKitesurfPremiumBoards } from './model.component';
import { Countrys } from './model.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {
  requestForm: UntypedFormGroup;
  private _sub;
  request: Request;
  airports = Airports;
  rentalCars = RentalCars;
  hotels = Hotels;
  hotelBoards = HotelBoards;
  countrys = Countrys;
  equipmentDurations = EquipmentDurations;
  equipmentWingPremiumBoards = EquipmentWingPremiumBoards;
  equipmentWindsurfPremiumBoards = EquipmentWindsurfPremiumBoards;
  equipmentWindsurfWorldCupBoards = EquipmentWindsurfWorldCupBoards;
  equipmentWindsurfKidsBoards = EquipmentWindsurfKidsBoards;
  equipmentKitesurfPremiumBoards = EquipmentKitesurfPremiumBoards;
  formSubmitted = false;
  result : any;
  param = {};

  constructor( private fb: UntypedFormBuilder, private translate: TranslateService, private postLambdaService: PostLambdaService) {
    translate.setDefaultLang('en');
    translate.addLangs(['de', 'es']);
    let browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|de|es/) ? browserLang : 'en');
  }

  ngOnInit() {
    this.formSubmitted = false;
    this.initForm()
  }

  onSubmit() {
    if( this.requestForm.valid ) {
      console.log('request form is valid');
      let formValue = this.requestForm.value;
      if (formValue.offerName !="") {
      this.param = {offerName: formValue.persons[formValue.offerName].firstName + " " + formValue.persons[formValue.offerName].lastName, email: formValue.email};
      } else {
        this.param = {offerName: "No Name!", email: formValue.email};
      }
      formValue.language = this.translate.currentLang;
      let filteredFormValue = JSON.parse(JSON.stringify(formValue), function(k, v){
        if (Array.isArray(v)) {
          var fArr = v.filter(e=>e);
          return fArr.length && fArr || undefined;
        } else if(typeof(v) === "object" && !Object.keys(v).length) {
          return undefined;
        } else if(v == "" || v =="false") {
          return undefined;
        } else {
          return v
        };
      });
      this._sub = this.postLambdaService.saveRequest(filteredFormValue)
         .subscribe(data => {
           console.log(data)
           this.result = data;
      });
      console.log('request form submitted' + filteredFormValue);
      this.formSubmitted = true;
    }
  }

  ngOnDestroy() {
     // clean subscription when component destroy
     if (this._sub) {
       this._sub.unsubscribe();
     }
   }

  initForm():void {
    let persons: UntypedFormArray = new UntypedFormArray([]);

    if (this.translate.currentLang == 'de') {
      this.requestForm = this.fb.group({
        arrival: '',
        departure: '',
        flight: '',
        transfer: '',
        rentalCar: '',
        hotel: '',
        hotelBoard: '',
        persons: persons,
        offerName: '0',
        customerNumber: '',
        passportNumber: '',
        address: '',
        postcode: '',
        city: '',
        country: 'DE',
        email: ['', [Validators.required, Validators.email]],
        phone: '',
        comment: '',
        privacy: ['', [Validators.requiredTrue]],
        newsletter: ''
      })
    } else if (this.translate.currentLang == 'es') {
      this.requestForm = this.fb.group({
        arrival: '',
        departure: '',
        flight: '',
        transfer: '',
        rentalCar: '',
        hotel: '',
        hotelBoard: '',
        persons: persons,
        offerName: '0',
        customerNumber: '',
        passportNumber: '',
        address: '',
        postcode: '',
        city: '',
        country: 'ES',
        email: ['', [Validators.required, Validators.email]],
        phone: '',
        comment: '',
        privacy: ['', [Validators.requiredTrue]],
        newsletter: ''
      })
    } else {
      this.requestForm = this.fb.group({
        arrival: '',
        departure: '',
        flight: '',
        transfer: '',
        rentalCar: '',
        hotel: '',
        hotelBoard: '',
        persons: persons,
        offerName: '0',
        customerNumber: '',
        passportNumber: '',
        address: '',
        postcode: '',
        city: '',
        country: 'GB',
        email: ['', [Validators.required, Validators.email]],
        phone: '',
        comment: '',
        privacy: ['', [Validators.requiredTrue]],
        newsletter: ''
      })
    };
    this.addPerson();
  }

  addPerson():void {
    let equipments : UntypedFormArray = new UntypedFormArray([]);
    let windsurfLessons : UntypedFormArray = new UntypedFormArray([]);
    let kitesurfLessons : UntypedFormArray = new UntypedFormArray([]);
    let wingfoilLessons : UntypedFormArray = new UntypedFormArray([]);
    let storages : UntypedFormArray = new UntypedFormArray([]);

    (<UntypedFormArray>this.requestForm.controls['persons']).push(
      new UntypedFormGroup({
        firstName: new UntypedFormControl(''),
        lastName: new UntypedFormControl(''),
        dateOfBirth: new UntypedFormControl(''),
        equipments: equipments,
        windsurfLessons: windsurfLessons,
        kitesurfLessons: kitesurfLessons,
        wingfoilLessons: wingfoilLessons,
        storages: storages
      })
    )
  }
  removePerson(personIndex: number):void {
    (<UntypedFormArray>this.requestForm.controls['persons'])
      .removeAt(personIndex);
  }

  addEquipment(personIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['equipments']).push(
        new UntypedFormGroup({
          type: new UntypedFormControl('Windsurf PREMIUM'),
          beginn: new UntypedFormControl(''),
          duration: new UntypedFormControl(''),
          board: new UntypedFormControl(''),
          insurance: new UntypedFormControl(false),
          wetsuit: new UntypedFormControl(false),
          harness: new UntypedFormControl(false),
          helmet: new UntypedFormControl(false),
          lifeVest: new UntypedFormControl(false),
          doubleUse: new UntypedFormControl(false),
          partnerSpecial: new UntypedFormControl(false),
          privateRental: new UntypedFormControl(false),
        })
    )
  }
  removeEquipment(personIndex: number, equipmentIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['equipments']).removeAt(equipmentIndex);
  }
  addWindsurfLesson(personIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['windsurfLessons']).push(
        new UntypedFormGroup({
          type: new UntypedFormControl(''),
          beginn: new UntypedFormControl(''),
          hourlyRental: new UntypedFormControl(''),
        })
    )
  }
  removeWindsurfLesson(personIndex: number, windsurfLessonIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['windsurfLessons']).removeAt(windsurfLessonIndex);
  }
  addKitesurfLesson(personIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['kitesurfLessons']).push(
        new UntypedFormGroup({
          type: new UntypedFormControl(''),
          beginn: new UntypedFormControl(''),
          groupSize: new UntypedFormControl(''),
          duration: new UntypedFormControl(''),
        })
    )
  }
  removeKitesurfLesson(personIndex: number, kitesurfLessonIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['kitesurfLessons']).removeAt(kitesurfLessonIndex);
  }
  addWingfoilLesson(personIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['wingfoilLessons']).push(
        new UntypedFormGroup({
          type: new UntypedFormControl(''),
          beginn: new UntypedFormControl(''),
          duration: new UntypedFormControl(''),
        })
    )
  }
  removeWingfoilLesson(personIndex: number, wingfoilLessonIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['wingfoilLessons']).removeAt(wingfoilLessonIndex);
  }
  addStorage(personIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['storages']).push(
        new UntypedFormGroup({
          type: new UntypedFormControl(''),
          beginn: new UntypedFormControl(''),
        })
    )
  }
  removeStorage(personIndex: number, storageIndex: number):void {
    (<UntypedFormArray>(<UntypedFormGroup>(<UntypedFormArray>this.requestForm.controls['persons'])
      .controls[personIndex]).controls['storages']).removeAt(storageIndex);
  }

  changeLanguage(language):void {
    this.translate.use(language)
  }

}
